import { Component } from "@angular/core";
import { LoaderService } from "@core/services/gigya/loader/loader.service";
import { CommonModule } from "@angular/common";
import { PrimeNGSharedModule } from "../../prime/prime-ng.module";

@Component({
  selector: "app-loader",
  standalone: true,
  imports: [CommonModule,PrimeNGSharedModule],
  templateUrl: "./loader.component.html",
  styleUrl: "./loader.component.scss",
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
